// extracted by mini-css-extract-plugin
export default {"header":"ForgotPasswordModal-module__header___3ERdu","description":"ForgotPasswordModal-module__description___31Vnz","spacer":"ForgotPasswordModal-module__spacer___2FMRI"};